import { Check } from "lucide-react";

const STEPS = [
  ["requested", "Request sent"],
  ["accepted", "Driver assigned"],
  ["arrived", "Driver arrived"],
  ["in_progress", "On the way"],
  ["completed", "Arrived · Pay cash"],
];

export const RideTimeline = ({ status }) => {
  const idx = STEPS.findIndex(([s]) => s === status);
  return (
    <ol data-testid="ride-timeline" className="space-y-3">
      {STEPS.map(([key, label], i) => {
        const done = i < idx || status === "completed";
        const current = i === idx && status !== "completed";
        return (
          <li key={key} className="flex items-center gap-3">
            <span
              className={`flex h-7 w-7 items-center justify-center rounded-full text-xs font-bold ${
                done ? "bg-blue-600 text-white" : current ? "pulse-ring bg-amber-400 text-slate-900" : "bg-slate-100 text-slate-400"
              }`}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
            </span>
            <span className={`text-sm ${done || current ? "font-semibold text-slate-900" : "text-slate-400"}`}>{label}</span>
          </li>
        );
      })}
    </ol>
  );
};
